// extracted by mini-css-extract-plugin
module.exports = {"moveIndividualContent":"MoveIndividualContent_moveIndividualContent___HrPQ"};